export default __webpack_public_path__ + "static/home-ea6d86dc71ad6fd71788c2b5fc7e7f4a.jpg";